import React, {FC} from 'react';

import {IntegrationTypeModel} from '../../../models/api/integrationTypesModel';
import {SettingsAppsPopularUrl} from '../../../models/url/settingsUrlModel';
import {AppsGrid} from '../layout/appsGrid';
import {SettingsAppCardContainer} from '../settingsAppCardContainer';
import {renderMultiLoadingState} from './settingsAppsPageHelpers';

/*
 * Constants.
 */

const maxIntegrationsToRender = 20;

/*
 * Props.
 */

interface SettingsAppsPopularPageProps {
  popularIntegrationTypes: ReadonlyArray<IntegrationTypeModel>;
  isIntegrationTypesLoading: boolean;
  url: SettingsAppsPopularUrl;
}

/*
 * Component.
 */

export const SettingsAppsPopularPage: FC<SettingsAppsPopularPageProps> = (props) => {
  const {popularIntegrationTypes, isIntegrationTypesLoading, url} = props;

  return (
    <AppsGrid
      isLoading={isIntegrationTypesLoading}
      renderLoadingState={renderMultiLoadingState}
      shouldHaveLoadingGradient
    >
      {popularIntegrationTypes.slice(0, maxIntegrationsToRender).map((integrationType) => (
        <SettingsAppCardContainer key={integrationType.id} integrationType={integrationType} url={url} />
      ))}
    </AppsGrid>
  );
};
